module.exports = __webpack_public_path__ + "img/logo2.b33a2946.png";